import { Get } from '@/modules/api/get'
import { Post } from '@/modules/api/post'
import { Delete } from '@/modules/api/delete'
export const API = {
  Get,
  Post,
  Delete
}
